export const toKebabCase = (source: string): string =>
  source
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();

export const slugify = (text: string) =>
  text
    .toString()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/Ä/g, 'Ae')
    .replace(/Ö/g, 'Oe')
    .replace(/Ü/g, 'Ue')
    .replace(/ß/g, 'ss')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\+/g, 'plus')
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-');

export const sanitizeHtml = (dirty: string): string => {
  return decodeURI(encodeURI(dirty).replaceAll('%E2%80%9D', '%22'));
};

export const stripHtmlTags = (html: string): string => {
  return html
    .replace(/<[^>]*?>/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};

export const capitalizeFirstLetter = (text: string): string => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
};
